export default class O2SConstants {

    // Karyotype Status
    static A_REFAIRE = "A REFAIRE";
    static A_RENSEIGNER = "A RENSEIGNER";
    static A_REALISER = "A REALISER";
    static NON_CONCERNE = "NON CONCERNE";
    static EN_COURS = "EN COURS";
    static DEFAVORABLE = "DEFAVORABLE";
    static FAVORABLE = "FAVORABLE";
}

/**
 * Couleurs réservées à l'affichage des bains dilueurs (dans l'ordre de leur utilisation selon le nombre de bains).
 * Si il y a plus de bains que de couleurs, on reprend l'ordre au début.
 */
export enum DilutorColors {
    CRIMSON = "crimson",
    LIME_GREEN = "limegreen",
    SLATE_GRAY = "slategray",
    ROYAL_BLUE = "royalblue",    
    GOLD = "gold",
    BLUE_VIOLET = "blueviolet",
    PLUM = "plum",
    TAN = "tan",
}

export enum DeviceTypes {
    BALANCE = "BALANCE",
    POMPE_DILUTION = "POMPE_DILUTION",
    PHOTOCOLORIMETRE = 'PC',
    ARQUIMEA = 'ARQUIMEA',
    CASA = 'CASA',
    ZEBRA = 'ZEBRA',
    AGP3500 = 'AGP3500',
    RQ800 = 'RQ800',
    PM43C = 'PM43C'
}

export enum ConditioningDevices {
    DISPATCH = "Dispatch",
    VOLUME = "Volume",
    ECHANTILLON = "Echant.",
    DOSES = "Doses",
    LOT = "Lot",
    AGP3500 = "AGP3500",
    RQ800 = "RQ800",
    PM43C = "PM43C"
}

export enum ConditioningMethods {
    SELFIX = 'S',
    BLISTER = 'B',
    VRAC = 'V',
    HETERO = 'H',
    TUBE = 'T'
}

export enum CASA_GET_PROPERTIES {
    SUJET = "subject",
    REFERENCE = "casereference",
    TOTAL_NOMBRE = "totnumber",
    TOTAL_POURCENTAGE = "totpercen",
    TOTAL_MML = "totmml",
    MOTILE_NORMAL_POURCENTAGE = "norpercen",
    MOTILE_NORMAL_NOMBRE = "nornumber",
    UTILE_POURCENTAGE = "usepercen",
    UTILE_NOMBRE = "usenumber",
    MOTILE_POURCENTAGE = "motpercen",
    MOTILE_NOMBRE = "motnumber",
    VOLUME_EJACULE = "ejaculatedvolume",
    GOUTTELETTES_PROXIMALES = "pdpercen",
    GOUTTELETTES_DISTALES = "ddpercen",
    QUEUES_COURBEES = "bentpercen",
    PROGRESSIVITE_POURCENTAGE = "progresspercen",
}

export enum PumpDeviceProperties {
    ROTATION_SPEED = "ROTATION_SPEED",
    DIRECTION = "DIRECTION",
    CALIBRATION_2_SEC = "CALIBRATION_2_SEC",
    CALIBRATION_15_SEC = "CALIBRATION_15_SEC"
}

export enum PhotocolorimeterProperties {
    FORMULA_PARAM_ID = "FORMULA_PARAM_ID"
}

export enum DurationDeviceRequestDefaults {
    CONNECTION_CHECK_OK = "CON_CHECK_OK",
    CONNECTION_CHECK_KO = "CON_CHECK_KO"
}

export enum AnswerDeviceRequestDefaults {
    CONNECTION_CHECK_PROPERTY = "connCheck",
    CONNECTION_CHECK_OK = "OK",
    CONNECTION_CHECK_KO = "KO"
}

// Constantes pour les offsets
export const VALID_OFFSETS = [2, 3, 4];
export const EXTENDED_OFFSETS = [3, 4, 5];

// Seuils pour le pourcentage d'utiles
export const LIVING_THRESHOLDS_CASA = {
    LOW: 40,
    MEDIUM: 65,
    HIGH: 70,
    VERY_HIGH: 80,
};

export const LIVING_THRESHOLDS_OPERATOR = {
    LOW: 50,
    MEDIUM: 70,
    HIGH: 75,
    VERY_HIGH: 85,
};

// Aptitudes
export const APTITUDES = {
    UNDEFINED : "?",
    UNMARKETABLE: "4",
    MEDIUM : "3",
    GOOD: "2",
    VERYGOOD: "1",
};

export enum ResourcesActionTagColors {
    access = "success",
    edit = "warning",
    generate = "info",
    view = ""
}

export enum UserRoleTagColors {
    GDPORC_Laborantin = "",
    GDPORC_ChefDeCentre = "success",
    GDPORC_ResponsableApplicatif = "info",
    GDPORC_Administrateur = "warning",
    OWNER = "danger"
}

export enum UserRoleHierarchy {
    GDPORC_Laborantin = "labo",
    GDPORC_ChefDeCentre = "chef",
    GDPORC_ResponsableApplicatif = "resp",
    GDPORC_Administrateur = "adm"
}

export enum ResourceParameterType {
    ELEMENT = "ELEMENT",
    ACTION = "ACTION",
    SCOPE = "SCOPE"
}

export enum ResourceActions {
    ACCESS = "access",
    EDIT = "edit",
    GENERATE = "generate",
    VIEW = "view"
}

export enum ResourceType {
    FIELD = "field",
    PAGE = "page",
    DOCUMENT = "document",
    ACTION = "action"
}

export enum O2SResources {
    AGENTDETAIL_FIELD_NAME = "agentdetail#field#Name",
    AGENTDETAIL_FIELD_FIRSTNAME = "agentdetail#field#FirstName",
    AGENTDETAIL_FIELD_ENTRYDATE = "agentdetail#field#EntryDate",
    
    ANIMALDETAIL_FIELD_ARMADA = "animaldetail#field#Armada",
    ANIMALDETAIL_FIELD_BOUCLE = "animaldetail#field#Boucle",
    ANIMALDETAIL_FIELD_CHEPTELNAISSEUR = "animaldetail#field#CheptelNaisseur",
    ANIMALDETAIL_FIELD_CODESCHEMA = "animaldetail#field#CodeSchema",
    ANIMALDETAIL_FIELD_DATEENTREE = "animaldetail#field#DateEntree",
    ANIMALDETAIL_FIELD_DATENAISSANCE = "animaldetail#field#DateNaissance",
    ANIMALDETAIL_FIELD_IFIP = "animaldetail#field#IFIP",
    ANIMALDETAIL_FIELD_INFOSITE = "animaldetail#field#InfoSite",
    ANIMALDETAIL_FIELD_NN = "animaldetail#field#NN",
    ANIMALDETAIL_FIELD_NOM = "animaldetail#field#Nom",
    ANIMALDETAIL_FIELD_NUMTATOO = "animaldetail#field#NumTatoo",
    ANIMALDETAIL_FIELD_PAYS = "animaldetail#field#Pays",
    ANIMALDETAIL_FIELD_PEREMERE = "animaldetail#field#PereMere",
    ANIMALDETAIL_FIELD_REFMAX = "animaldetail#field#RefMax",
    ANIMALDETAIL_FIELD_STATUTCARYOTYPE = "animaldetail#field#StatutCaryotype",
    ANIMALDETAIL_FIELD_TATOUAGE = "animaldetail#field#Tatouage",
    ANIMALTILE_FIELD_ANIMALADMIN = "animaltile#field#AnimalAdmin",
    OPTIONTILE_FIELD_OPTIONPRODUCTION = "optiontile#field#OptionProduction",
    ANIMAL_ACTION_PATHOLOGIE = "animal#action#Pathologie",
    ANIMAL_ACTION_TRAITEMENT = "animal#action#Traitement",
    ANIMAL_ACTION_MUTATIONINTERNE = "animal#action#MutationInterne",
    ANIMAL_ACTION_PSLOT = "animal#action#PSLot",
    ANIMAL_ACTION_AGREMENTASU = "animal#action#AgrementASU",
    ANIMAL_ACTION_GRILLE = "animal#action#Grille",
    ANIMAL_ACTION_EXPORT = "animal#action#Export",
    ANIMAL_ACTION_ACTIONSCONFIGUREES = "animal#action#ActionsConfigurees",
    CENTER_ACTION_CREATESTUD = "center#action#CreateStud",
    CENTER_ACTION_EDITSTUD = "center#action#EditStud",
    CTG_ACTION_CREATECTG = "ctg#action#CreateCTG",
    CTG_ACTION_EDITCTG = "ctg#action#EditCTG",
    ELEVAGE_ACTION_CREATEBREEDINGSTUD = "elevage#action#CreateBreedingStud",
    ELEVAGE_ACTION_EDITBREEDINGSTUD = "elevage#action#EditBreedingStud",
    ELEVAGE_FIELD_BREEDINGSTUDSTATUS = "elevage#field#BreedingStudStatus",
    FABRICATION_ACTION_INFOBESOINDISPATCH = "fabrication#action#infoBesoinDispatch",
    FABRICATION_FIELD_DATE = "fabrication#field#Date",
    GLOBAL_PAGE_CALIBRATIONPOMPE = "global#page#CalibrationPompe",
    GLOBAL_PAGE_COMPONENTS = "global#page#Components",
    GLOBAL_PAGE_CONTROLDILUEURS = "global#page#ControlDilueurs",
    GLOBAL_PAGE_ETALONNAGEPHOTOCOLORIMETRE = "global#page#EtalonnagePhotocolorimetre",
    GLOBAL_PAGE_GESTIONRESSOURCES = "global#page#GestionRessources",
    GLOBAL_PAGE_INFOUSER = "global#page#InfoUser",
    GLOBAL_PAGE_LISTECARYOTYPE = "global#page#ListeCaryotype",
    GLOBAL_PAGE_LISTECENTRES = "global#page#ListeCentres",
    GLOBAL_PAGE_LISTECOLLABORATEURS = "global#page#ListeCollaborateurs",
    GLOBAL_PAGE_LISTECOMMANDE = "global#page#ListeCommande",
    GLOBAL_PAGE_LISTECONSULTATIONSTOCK = "global#page#ListeConsultationStock",
    GLOBAL_PAGE_LISTECTG = "global#page#ListeCTG",
    GLOBAL_PAGE_LISTEDEVICES = "global#page#ListeDevices",
    GLOBAL_PAGE_LISTEDILUEURS = "global#page#ListeDilueurs",
    GLOBAL_PAGE_LISTEELEVAGE = "global#page#ListeElevage",
    GLOBAL_PAGE_LISTEEVENEMENTSPRELEVEMENT = "global#page#ListeEvenementsPrelevement",
    GLOBAL_PAGE_LISTEEVENEMENTSSTATION = "global#page#ListeEvenementsStation",
    GLOBAL_PAGE_LISTEANIMAUXSANITAIRE = "global#page#ListeAnimauxSanitaire",
    GLOBAL_PAGE_LISTEHISTORIQUESTATUTCOMMANDE = "global#page#ListeHistoriqueStatutCommande",
    GLOBAL_PAGE_LISTELAMES = "global#page#ListeLames",
    GLOBAL_PAGE_LISTEMOVEMENTSSTOCK = "global#page#ListeMovementsStock",
    GLOBAL_PAGE_LISTEMUTATION = "global#page#ListeMutation",
    GLOBAL_PAGE_LISTEOWNER = "global#page#ListeOwner",
    GLOBAL_PAGE_LISTEPARAMETRES = "global#page#ListeParametres",
    GLOBAL_PAGE_LISTEPHARMACIE = "global#page#ListePharmacie",
    GLOBAL_PAGE_LISTEPRELEVEMENTS = "global#page#ListePrelevements",
    GLOBAL_PAGE_LISTEPROVIDER = "global#page#ListeProvider",
    GLOBAL_PAGE_LISTERESERVE = "global#page#ListeReserve",
    GLOBAL_PAGE_LISTEREFORMES = "global#page#ListeReformes",
    GLOBAL_PAGE_LISTETYPEPOUDRES = "global#page#ListeTypePoudres",
    GLOBAL_PAGE_OPTIONUSER = "global#page#OptionUser",
    GLOBAL_PAGE_ORIENTATIONDOSES = "global#page#OrientationDoses",
    GLOBAL_PAGE_PREPARATIONREFORMES = "global#page#PreparationReformes",
    GLOBAL_PAGE_PRODUCTION = "production#page#Production",
    GLOBAL_PAGE_SUIVIFABRICATION = "global#page#SuiviFabrication",
    GLOBAL_PAGE_SUIVIQUALITE = "global#page#SuiviQualite",
    GLOBAL_PAGE_TESTMESURE = "global#page#TestMesure",
    IDENTIFICATIONANIMALTILE_FIELD_ANIMALRESPONSABLE = "identificationanimaltile#field#AnimalResponsable",
    OPTIONSLISTDEVICES_FIELD_OPTIONSPRODUCTION = "optionslistdevices#field#Production",
    ORDER_ACTION_CANCELORDER = "order#action#CancelOrder",
    ORDER_ACTION_GENERATEORDER = "order#action#GenerateOrder",
    ORDER_ACTION_RECEIVEORDER = "order#action#ReceiveOrder",
    ORDER_ACTION_REFUSEORDER = "order#action#RefuseOrder",
    PHARMACY_ACTION_EDITMEDECINE = "pharmacy#action#EditMedecine",
    PRODUCTION_DOCUMENT_PRODUCTION = "production#document#Production",
    REFORMDETAIL_FIELD_CANCELREFORM = "reformdetail#field#CancelReform",
    RESERVATION_DOCUMENT_RESERVATIONDOCUMENT = "reservation#document#ReservationDocument",
    RESERVATION_FIELD_VIEWRESERVES = "reservation#field#ViewReserves",
    THIRDPARTIES_ACTION_CREATETIERS = "thirdparties#action#CreateTiers",
    THIRDPARTIES_ACTION_EDITTIERS = "thirdparties#action#EditTiers"


}

export enum OrientationOptions {
    SELECTED_MONO_DEVICES = "ORIENTATION_MONO_SELECTED_DEVICES",
    SELECTED_HETERO_DEVICES = "ORIENTATION_HETERO_SELECTED_DEVICES",
    SELECTED_PACKAGINGS = "ORIENTATION_SELECTED_PACKAGINGS"
}

export enum PumpDeliveryStatus {
    IDLE = "IDLE",
    TESTING = "TESTING...",
    WAITING_START = "WAITING_START...",
    DELIVERING = "DELIVERING...",
    WAITING_END = "WAITING_END...",
    STOPPING = "STOPPING...",
    STOPPED = "STOPPED",
    STOP_FAILED = "STOP_FAILED",
    FAILED = "FAILED",
    START_FAILED = "START_FAILED",
    END_FAILED = "END_FAILED",
    COMPLETE ="COMPLETE",
    MANUAL = "MANUAL"
}

export enum InitializationStatus {
    IDLE = "IDLE",
    MAIN_INITIALIZATION = "MAIN_INITIALIZATION",
    DONE = "DONE"
}

export enum CASAProductionOptions {
    THRESHOLD_CASA_NORMAUX_OPTION = "THRESHOLD_CASA_NORMAUX",
    THRESHOLD_CASA_UTILE_OPTION = "THRESHOLD_CASA_UTILE",
    THRESHOLD_CASA_MOTILITY_OPTION = "THRESHOLD_CASA_MOTILITY"
}

export enum OperatorProductionOptions {
    THRESHOLD_MOTILITY_OPTION = "THRESHOLD_MOTILITY",
    THRESHOLD_PRC_LIVING_OPTION = "THRESHOLD_PRC_LIVING"
}

export enum BuildingBoarNameDisplayTypes {
    NAME = "Nom",
    WORK_NUMBER = "N° de travail"
}

export enum MountingPlan {
    GRID_TILE_SIZE = 50,
    CUBICLE_TILE_WIDTH = 3,
    CUBICLE_TILE_HEIGHT = 2,
    LETTER_HEADER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ"
}

export enum MountingPlanElements {
    WAITING = "En attente",
    EXIT = "Sortie",
    MOUNTING_ROOM = "Salle de monte",
    INFIRMARY = "Infirmerie",
    CUSTOM = "Custom",
    CUBICLE = "Logette",

    NONE = "Aucun",
    ERASE = "Effacer"
}

export enum MountingPlanMode {
    DISPLAY = "display",
    EDITION = "edition"
}

export enum MountingPlanOptions {
    /** Ajouter l'id du bâtiment lors de l'utilisation */
    PLAN_SELECTED_SECTORS_FOR_BUILDING_ = "PLAN_SELECTED_SECTORS_FOR_BUILDING_"
}

export enum MountingPlanPremiumBoarOptions {
    PREMIUM_REQUIRED_CONTROLS_AMOUNT = "PREMIUM_REQUIRED_CONTROLS_AMOUNT",

    // Si autre que 'DEFAULT', utiliser le code schéma ou race pour les règles spécifiques
    PREMIUM_CASA_NORMAL_THRESHOLD = "PREMIUM_CASA_LIVING_THRESHOLD",
    PREMIUM_CASA_USEFUL_THRESHOLD = "PREMIUM_CASA_USEFUL_THRESHOLD",
    PREMIUM_CASA_MOTILITY_THRESHOLD = "PREMIUM_CASA_MOTILITY_THRESHOLD",

    PREMIUM_OPERATOR_LIVING_THRESHOLD = "PREMIUM_OPERATOR_LIVING_THRESHOLD",
    PREMIUM_OPERATOR_MOTILITY_THRESHOLD = "PREMIUM_OPERATOR_MOTILITY_THRESHOLD",
}

export const PrintPageFormats = {
    a4: { width: 210, height: 297, topMargin: 25.4, rightMargin: 25.4, bottomMargin: 25.4, leftMargin: 25.4 },
    usLetter: { width: 216, height: 279, topMargin: 25.4, rightMargin: 25.4, bottomMargin: 25.4, leftMargin: 25.4 }
}

export enum LocationTypes {
    EXIT = "Sortie",
    MOUNTING = "Salle de monte",
    INFIRMARY = "Infirmerie",
    CUSTOM = "Custom",
    WAITING = "En attente",
    CUBICLE = "Logette"
}